import { graphql, useStaticQuery } from 'gatsby';

export default () => {
  const data = useStaticQuery(
    graphql`
      {
        siteJson {
          title
          footerLinks {
            name
            link
          }
        }
        allBadgesJson {
          nodes {
            name
            src {
              childImageSharp {
                gatsbyImageData(width: 150, quality: 100, layout: FIXED)
              }
            }
          }
        }
      }
    `,
  );
  return data;
};
